import React, { useContext, useState } from 'react';

interface MarketingOptInContextValue {
  marketingEmailsOptedIn: boolean | null;
  setMarketingEmailsOptedIn: (value: boolean) => void;
}

const MarketingOptInContext = React.createContext<MarketingOptInContextValue | undefined>(undefined);
export default MarketingOptInContext;

interface MarketingOptInProviderProps {
  children: React.ReactNode;
}

export function MarketingOptInProvider({ children }: MarketingOptInProviderProps) {
  const [marketingEmailsOptedIn, setMarketingEmailsOptedIn] = useState<boolean | null>(null);

  return (
    <MarketingOptInContext.Provider value={{ marketingEmailsOptedIn, setMarketingEmailsOptedIn }}>
      {children}
    </MarketingOptInContext.Provider>
  );
}

export function useMarketingOptIn(): MarketingOptInContextValue {
  const context = useContext(MarketingOptInContext);
  if (!context) {
    throw new Error('useMarketingOptIn must be used within a MarketingOptInProvider');
  }
  return context;
}
